export const checkoutFeatureFlags = {
  informationIcon: false,
};
